import React from 'react';
import styled from 'styled-components';

import Link from 'components/core/link';
import useTranslation from 'hooks/use-translation';
import usePaths from 'src/hooks/use-paths';
import useProductQueryParams from 'src/hooks/use-product-query-params';

export function ShopAllProductsLink(): JSX.Element {
  const { t } = useTranslation();
  const { href } = usePaths({ search: true });
  const { queryParams } = useProductQueryParams();

  const query = queryParams.menuType ? { menuType: queryParams.menuType } : undefined;

  return (
    <StyledLink href={href} query={query} data-testid='shop-all-products-link'>
      {t('productList.shopAllProducts', 'Shop All Products')}
    </StyledLink>
  );
}

const StyledLink = styled(Link)`
  display: block;
  width: 100%;
  margin: 32px 0;
  text-align: center;
  text-decoration: none;
  text-transform: var(--dct--customized-textTransforms-links, none);
  font-size: 14px;
  font-weight: bold;
  color: var(--dcm-shop-all-products-link-color, #0b99e6);

  &:hover {
    text-decoration: underline;
  }
`;
